const INITIAL_STATE = {
  unitsMeasureList: []
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SET_UNITS_MEASURE': {
      return { ...state, unitsMeasureList: action.unitsMeasure };
    }
    default:
      return state;
  }
};
